import {AppUrls} from 'shared/config/model/urls';

import React from 'react';
import {useSearchParams} from 'react-router-dom';
import {t} from '@lingui/core/macro';

import LinkButton from 'shared/ui/Button/LinkButton/LinkButton';

import AuthWrapper from '../AuthWrapper';

import styles from '../Auth.module.scss';

const PasswordResetSent: React.FC = () => {
    const [query] = useSearchParams();
    const email = query.get('email') ?? '';
    return (
        <AuthWrapper>
            <div className={styles.title_container}>
                <h2 className={styles.title}>
                    {t`Восстановление доступа`}
                </h2>
                <p>
                    {t`На указанный вами адрес`} {email} {t`отправлено письмо, содержащее ссылку для сброса пароля`}.
                </p>
            </div>

            <LinkButton
                href={AppUrls.LOGIN}
                primary
                block
            >
                {t`Продолжить`}
            </LinkButton>
        </AuthWrapper>
    );
};

export default PasswordResetSent;